import React from 'react';

const DisneyCategory = () => {
    return(
        <div className='cards-categories'>
            <div>
                <img src="https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/EEA8EA3EF5635CD7B3DCA1339908AF295E505ACAA7C1AEF945EE859ED4D31F7C/scale?width=400&aspectRatio=1.78&format=jpeg" alt="" />
            </div>

            <div>
                <img src="https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/B876E5B073AB5C202D2268F9F7EC1B0E72E621FEDB11D4B1C28F4B5E51D8F6D6/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal" alt="" />
            </div>
                        
            <div>
                <img src="https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/BD76E4183CDA5DB2A942DB58332A403761A0699692E1BADD84287472D1BD9E12/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal" alt="" />
            </div>
                        
            <div>
                <img src="/images/moana-img-disney.jpg" alt="" />
            </div>
        </div>
    )
}

export default DisneyCategory;
